const routes = {
    HOME: '/',
    LOGIN: '/login',
    NOT_FOUND: '*',
    RESET: '/reset',
    SIDEBAR: '/sidebar',
    NEWS_AND_EVENTS: '/newsandevents',
    USERS: '/users',
    CHARGEABLE_PRODUCTS: '/chargeableproducts',
    ITEM_LIST: '/itemlist',
    KNOWLEDGE: '/knowledge',
    MISSIONS: '/missions',
    ADDITIONAL_MISSIONS: '/additionalmissions',
    APP_USERS: '/appusers',
    REWARDS: '/rewards',
    DOCUMENTS: '/documents',
    REGULATIONS: '/regulations',
    ABOUT: '/about',
    CHAT: '/chat',
    MEETINGS: '/meetings',
    CHAT_SCHEDULE: '/chatschedule',
};

export default routes;
